"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lesson = void 0;
const executor_1 = require("./executor");
const Guard_1 = require("./Guard");
const Help_1 = require("./Help");
const LessonNode_1 = require("./LessonNode");
const LessonStructure_1 = require("./LessonStructure");
const Orchestrator_1 = require("./Orchestrator");
const types_1 = require("./types");
class Lesson {
    constructor(lesson, extras) {
        // currentNode = -1;
        this.executingNode = -1;
        this.errorsComitted = 0;
        this.id = lesson.id;
        this.estimatedTime = lesson.estimatedTime;
        this.version = lesson.version;
        this.roles = lesson.roles;
        this.extras = extras;
        this.help = (lesson.graph.help || []).map((help) => new Help_1.Help(help, this.extras));
        this.lessonNodes = lesson.graph.nodes.map((node) => new LessonNode_1.LessonNode(node, this.extras));
        this.extras.lessonStructure = new LessonStructure_1.LessonStructure(lesson.graph.edges, this.lessonNodes, this.extras);
        this.orchestrator = new Orchestrator_1.Orchestrator(this, this.extras);
    }
    start() {
        if (!this.extras.role) {
            throw new Error(`No role is set`);
        }
        const foundRole = this.roles.find((role) => role.name === this.extras.role);
        if (!foundRole) {
            throw new Error(`Role not found in lesson`);
        }
        this.extras.logger.info({
            message: `Started lesson`,
            role: this.extras.role,
            mode: this.extras.mode,
        });
        if (this.extras.mode === executor_1.ExecutorModes.DEMO) {
            this.orchestrator.start();
        }
        else {
            this.startUserMode();
        }
    }
    getNextIndex() {
        if (!this.structureIterator) {
            this.structureIterator = this.extras.lessonStructure.getNextNode();
        }
        const next = this.structureIterator.next();
        if (!next.done) {
            return next.value;
        }
        else {
            if (this.extras.executorStatus !== executor_1.ExecutorStatus.LessonCompleted) {
                // in case lesson is not already marked complete
                this.extras.lessonComplete();
            }
        }
        return -1;
    }
    // both guided and manual are user modes
    startUserMode() {
        this.extras.doSyncComment('starting user mode');
        this.executingNode = this.getNextIndex();
        if (this.executingNode !== -1) {
            this.executeSystemActions();
        }
    }
    findNodeForValidation() {
        return __awaiter(this, void 0, void 0, function* () {
            let node = this.lessonNodes[this.executingNode];
            // if (node.isNodeInProgress() && !node.isComplete()) {
            //   // there is node in progress and is still incomplete, continue execution with that node
            //   return node;
            // }
            if (node.isNodeInProgress()) {
                // the current node is already in progress
                if (!node.isComplete()) {
                    // since it is not yet done, return the same.
                    return node;
                }
            }
            if (node.isComplete()) {
                this.executingNode = this.getNextIndex();
                if (this.isComplete()) {
                    return undefined;
                }
                return yield this.findNodeForValidation();
            }
            else {
                // node is neither started nor is it complete
                const guardResult = Guard_1.Guard.evaluateAll(node.guards, this.extras, node);
                if (guardResult.proceed) {
                    return node;
                }
                else {
                    this.executingNode = this.getNextIndex();
                    if (this.isComplete()) {
                        return undefined;
                    }
                    return yield this.findNodeForValidation();
                }
            }
            // // we need to find a new node that is acceptable by the guards
            // const guardRes = Guard.evaluateAll(node.guards, this.extras, node);
            // if (guardRes.proceed) {
            //   // cleared to proceed
            //   return node;
            // } else {
            //   this.executingNode = this.getNextIndex();
            //   if (this.isComplete()) {
            //     return undefined;
            //   }
            //   return await this.findNodeForValidation();
            // }
        });
    }
    validate(value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.errorsComitted >= 3) {
                this.extras.doControlEmit(types_1.ControlActions.MaxErrorsReached, `Lesson terminated, maximum errors threshold reached.`);
                this.extras.doControlEmit(types_1.ControlActions.LessonComplete);
                this.extras.executorStatus = executor_1.ExecutorStatus.Error;
                return false;
            }
            const node = yield this.findNodeForValidation();
            if (!node) {
                this.extras.logger.error({
                    msg: `Lesson is already complete`,
                });
                throw new Error('Lesson is already complete');
            }
            else {
                const nodeRes = yield node.validate(value);
                if (nodeRes.skipped) {
                    return yield this.validate(value);
                }
                if (!nodeRes.result) {
                    this.errorsComitted++;
                    this.extras.doControlEmit(types_1.ControlActions.InvalidActionInput, {
                        action: value,
                    });
                    if (this.errorsComitted >= 3) {
                        this.extras.logger.error({
                            msg: `Lesson terminated, maximum errors commited`,
                        });
                    }
                }
                if (nodeRes.result) {
                    this.extras.doControlEmit(types_1.ControlActions.ActionValid, {
                        action: value,
                    });
                    // if this validation is successful only then try to do any pending system actions;
                    this.delayedSystemActions();
                }
                return nodeRes.result;
            }
        });
    }
    delayedSystemActions() {
        setTimeout(() => {
            this.executeSystemActions();
        }, 10);
    }
    reset() {
        this.errorsComitted = 0;
        this.executingNode = -1;
        this.extras.reset();
        this.lessonNodes && this.lessonNodes.forEach((lNode) => lNode.reset());
    }
    isComplete() {
        return this.extras.executorStatus === executor_1.ExecutorStatus.LessonCompleted;
    }
    executeSystemActions() {
        return __awaiter(this, void 0, void 0, function* () {
            //do all possible actions from this point forward
            let executionDone = false;
            while (!executionDone) {
                const node = yield this.findNodeForValidation();
                if (node) {
                    while (node.hasMoreSystemActions()) {
                        const action = yield node.getSystemAction();
                        if (!action.skipped) {
                            this.extras.doActionEmit(action.result);
                        }
                    }
                    if (node.isComplete()) {
                        // if the current node is exhausted
                        // inspect the next node for possible system actions
                        // this.executingNode = this.getNextIndex();
                        yield this.findNodeForValidation();
                        if (this.isComplete()) {
                            // all nodes are done, meaning the lesson is done
                            executionDone = true;
                            this.lessonComplete();
                        }
                    }
                    else {
                        // the current lesson node is not done, but there are
                        // no more system actions to fire, try to consume all actions
                        // that fail guards after this
                        const res = yield this.consumeGuardFailingNodes();
                        if (res) {
                            // we found a node that has not failed guards
                            if (!node.hasMoreSystemActions()) {
                                // if there are no more system actions after skipping guard failing nodes then we are done
                                // other wise we have to keep looking.
                                executionDone = true;
                            }
                        }
                        else {
                            // Lesson complete
                            this.lessonComplete();
                            return;
                        }
                    }
                }
                else {
                    executionDone = true;
                }
            }
        });
    }
    getHelp() {
        const currHelp = this.help.map((help) => help.getHelpVal());
        const node = this.lessonNodes[this.executingNode];
        if (node) {
            const lessonNode = node;
            return [...currHelp, ...lessonNode.getHelp()];
        }
        else {
            return currHelp;
        }
    }
    lessonComplete() {
        if (this.extras.executorStatus !== executor_1.ExecutorStatus.LessonCompleted) {
            this.extras.lessonComplete();
        }
    }
    consumeGuardFailingNodes() {
        return __awaiter(this, void 0, void 0, function* () {
            while (true) {
                if (this.isComplete()) {
                    return false;
                }
                const node = this.lessonNodes[this.executingNode];
                const res = yield node.consumeGuardFailingNodes();
                if (res) {
                    return true;
                }
                else {
                    this.executingNode = this.getNextIndex();
                }
            }
        });
    }
}
exports.Lesson = Lesson;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGVzc29uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9MZXNzb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQ0EseUNBQTJEO0FBRTNELG1DQUFnQztBQUNoQyxpQ0FBOEI7QUFDOUIsNkNBQTBDO0FBQzFDLHVEQUFvRDtBQUNwRCxpREFBOEM7QUFDOUMsbUNBQStEO0FBRS9ELE1BQWEsTUFBTTtJQWdCakIsWUFBWSxNQUFlLEVBQUUsTUFBYztRQUwzQyxvQkFBb0I7UUFDcEIsa0JBQWEsR0FBRyxDQUFDLENBQUMsQ0FBQztRQUVYLG1CQUFjLEdBQUcsQ0FBQyxDQUFDO1FBR3pCLElBQUksQ0FBQyxFQUFFLEdBQUcsTUFBTSxDQUFDLEVBQUUsQ0FBQztRQUNwQixJQUFJLENBQUMsYUFBYSxHQUFHLE1BQU0sQ0FBQyxhQUFhLENBQUM7UUFDMUMsSUFBSSxDQUFDLE9BQU8sR0FBRyxNQUFNLENBQUMsT0FBTyxDQUFDO1FBQzlCLElBQUksQ0FBQyxLQUFLLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQztRQUMxQixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQztRQUNyQixJQUFJLENBQUMsSUFBSSxHQUFHLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxJQUFJLElBQUksRUFBRSxDQUFDLENBQUMsR0FBRyxDQUN2QyxDQUFDLElBQUksRUFBRSxFQUFFLENBQUMsSUFBSSxXQUFJLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FDdEMsQ0FBQztRQUNGLElBQUksQ0FBQyxXQUFXLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUN2QyxDQUFDLElBQUksRUFBRSxFQUFFLENBQUMsSUFBSSx1QkFBVSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDLENBQzVDLENBQUM7UUFDRixJQUFJLENBQUMsTUFBTSxDQUFDLGVBQWUsR0FBRyxJQUFJLGlDQUFlLENBQy9DLE1BQU0sQ0FBQyxLQUFLLENBQUMsS0FBSyxFQUNsQixJQUFJLENBQUMsV0FBVyxFQUNoQixJQUFJLENBQUMsTUFBTSxDQUNaLENBQUM7UUFDRixJQUFJLENBQUMsWUFBWSxHQUFHLElBQUksMkJBQVksQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQzFELENBQUM7SUFDRCxLQUFLO1FBQ0gsSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxFQUFFO1lBQ3JCLE1BQU0sSUFBSSxLQUFLLENBQUMsZ0JBQWdCLENBQUMsQ0FBQztTQUNuQztRQUNELE1BQU0sU0FBUyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxJQUFJLENBQUMsSUFBSSxLQUFLLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDNUUsSUFBSSxDQUFDLFNBQVMsRUFBRTtZQUNkLE1BQU0sSUFBSSxLQUFLLENBQUMsMEJBQTBCLENBQUMsQ0FBQztTQUM3QztRQUNELElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQztZQUN0QixPQUFPLEVBQUUsZ0JBQWdCO1lBQ3pCLElBQUksRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUk7WUFDdEIsSUFBSSxFQUFFLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSTtTQUN2QixDQUFDLENBQUM7UUFDSCxJQUFJLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxLQUFLLHdCQUFhLENBQUMsSUFBSSxFQUFFO1lBQzNDLElBQUksQ0FBQyxZQUFZLENBQUMsS0FBSyxFQUFFLENBQUM7U0FDM0I7YUFBTTtZQUNMLElBQUksQ0FBQyxhQUFhLEVBQUUsQ0FBQztTQUN0QjtJQUNILENBQUM7SUFDRCxZQUFZO1FBQ1YsSUFBSSxDQUFDLElBQUksQ0FBQyxpQkFBaUIsRUFBRTtZQUMzQixJQUFJLENBQUMsaUJBQWlCLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxlQUFlLENBQUMsV0FBVyxFQUFFLENBQUM7U0FDcEU7UUFDRCxNQUFNLElBQUksR0FBRyxJQUFJLENBQUMsaUJBQWlCLENBQUMsSUFBSSxFQUFFLENBQUM7UUFDM0MsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUU7WUFDZCxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUM7U0FDbkI7YUFBTTtZQUNMLElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQyxjQUFjLEtBQUsseUJBQWMsQ0FBQyxlQUFlLEVBQUU7Z0JBQ2pFLGdEQUFnRDtnQkFDaEQsSUFBSSxDQUFDLE1BQU0sQ0FBQyxjQUFjLEVBQUUsQ0FBQzthQUM5QjtTQUNGO1FBQ0QsT0FBTyxDQUFDLENBQUMsQ0FBQztJQUNaLENBQUM7SUFDRCx3Q0FBd0M7SUFDeEMsYUFBYTtRQUNYLElBQUksQ0FBQyxNQUFNLENBQUMsYUFBYSxDQUFDLG9CQUFvQixDQUFDLENBQUM7UUFDaEQsSUFBSSxDQUFDLGFBQWEsR0FBRyxJQUFJLENBQUMsWUFBWSxFQUFFLENBQUM7UUFDekMsSUFBSSxJQUFJLENBQUMsYUFBYSxLQUFLLENBQUMsQ0FBQyxFQUFFO1lBQzdCLElBQUksQ0FBQyxvQkFBb0IsRUFBRSxDQUFDO1NBQzdCO0lBQ0gsQ0FBQztJQUNLLHFCQUFxQjs7WUFDekIsSUFBSSxJQUFJLEdBQUcsSUFBSSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLENBQUM7WUFDaEQsdURBQXVEO1lBQ3ZELDRGQUE0RjtZQUM1RixpQkFBaUI7WUFDakIsSUFBSTtZQUVKLElBQUksSUFBSSxDQUFDLGdCQUFnQixFQUFFLEVBQUU7Z0JBQzNCLDBDQUEwQztnQkFDMUMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLEVBQUUsRUFBRTtvQkFDdEIsNkNBQTZDO29CQUM3QyxPQUFPLElBQUksQ0FBQztpQkFDYjthQUNGO1lBQ0QsSUFBSSxJQUFJLENBQUMsVUFBVSxFQUFFLEVBQUU7Z0JBQ3JCLElBQUksQ0FBQyxhQUFhLEdBQUcsSUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDO2dCQUN6QyxJQUFJLElBQUksQ0FBQyxVQUFVLEVBQUUsRUFBRTtvQkFDckIsT0FBTyxTQUFTLENBQUM7aUJBQ2xCO2dCQUNELE9BQU8sTUFBTSxJQUFJLENBQUMscUJBQXFCLEVBQUUsQ0FBQzthQUMzQztpQkFBTTtnQkFDTCw2Q0FBNkM7Z0JBQzdDLE1BQU0sV0FBVyxHQUFHLGFBQUssQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTSxFQUFFLElBQUksQ0FBQyxDQUFDO2dCQUN0RSxJQUFJLFdBQVcsQ0FBQyxPQUFPLEVBQUU7b0JBQ3ZCLE9BQU8sSUFBSSxDQUFDO2lCQUNiO3FCQUFNO29CQUNMLElBQUksQ0FBQyxhQUFhLEdBQUcsSUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDO29CQUN6QyxJQUFJLElBQUksQ0FBQyxVQUFVLEVBQUUsRUFBRTt3QkFDckIsT0FBTyxTQUFTLENBQUM7cUJBQ2xCO29CQUNELE9BQU8sTUFBTSxJQUFJLENBQUMscUJBQXFCLEVBQUUsQ0FBQztpQkFDM0M7YUFDRjtZQUVELGlFQUFpRTtZQUNqRSxzRUFBc0U7WUFDdEUsMEJBQTBCO1lBQzFCLDBCQUEwQjtZQUMxQixpQkFBaUI7WUFDakIsV0FBVztZQUNYLDhDQUE4QztZQUM5Qyw2QkFBNkI7WUFDN0Isd0JBQXdCO1lBQ3hCLE1BQU07WUFDTiwrQ0FBK0M7WUFDL0MsSUFBSTtRQUNOLENBQUM7S0FBQTtJQUNLLFFBQVEsQ0FBQyxLQUFVOztZQUN2QixJQUFJLElBQUksQ0FBQyxjQUFjLElBQUksQ0FBQyxFQUFFO2dCQUM1QixJQUFJLENBQUMsTUFBTSxDQUFDLGFBQWEsQ0FDdkIsc0JBQWMsQ0FBQyxnQkFBZ0IsRUFDL0Isc0RBQXNELENBQ3ZELENBQUM7Z0JBQ0YsSUFBSSxDQUFDLE1BQU0sQ0FBQyxhQUFhLENBQUMsc0JBQWMsQ0FBQyxjQUFjLENBQUMsQ0FBQztnQkFDekQsSUFBSSxDQUFDLE1BQU0sQ0FBQyxjQUFjLEdBQUcseUJBQWMsQ0FBQyxLQUFLLENBQUM7Z0JBQ2xELE9BQU8sS0FBSyxDQUFDO2FBQ2Q7WUFDRCxNQUFNLElBQUksR0FBRyxNQUFNLElBQUksQ0FBQyxxQkFBcUIsRUFBRSxDQUFDO1lBQ2hELElBQUksQ0FBQyxJQUFJLEVBQUU7Z0JBQ1QsSUFBSSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDO29CQUN2QixHQUFHLEVBQUUsNEJBQTRCO2lCQUNsQyxDQUFDLENBQUM7Z0JBQ0gsTUFBTSxJQUFJLEtBQUssQ0FBQyw0QkFBNEIsQ0FBQyxDQUFDO2FBQy9DO2lCQUFNO2dCQUNMLE1BQU0sT0FBTyxHQUFHLE1BQU0sSUFBSSxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQztnQkFDM0MsSUFBSSxPQUFPLENBQUMsT0FBTyxFQUFFO29CQUNuQixPQUFPLE1BQU0sSUFBSSxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQztpQkFDbkM7Z0JBQ0QsSUFBSSxDQUFDLE9BQU8sQ0FBQyxNQUFNLEVBQUU7b0JBQ25CLElBQUksQ0FBQyxjQUFjLEVBQUUsQ0FBQztvQkFDdEIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxhQUFhLENBQUMsc0JBQWMsQ0FBQyxrQkFBa0IsRUFBRTt3QkFDM0QsTUFBTSxFQUFFLEtBQUs7cUJBQ2QsQ0FBQyxDQUFDO29CQUNILElBQUksSUFBSSxDQUFDLGNBQWMsSUFBSSxDQUFDLEVBQUU7d0JBQzVCLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQzs0QkFDdkIsR0FBRyxFQUFFLDRDQUE0Qzt5QkFDbEQsQ0FBQyxDQUFDO3FCQUNKO2lCQUNGO2dCQUNELElBQUksT0FBTyxDQUFDLE1BQU0sRUFBRTtvQkFDbEIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxhQUFhLENBQUMsc0JBQWMsQ0FBQyxXQUFXLEVBQUU7d0JBQ3BELE1BQU0sRUFBRSxLQUFLO3FCQUNkLENBQUMsQ0FBQztvQkFDSCxtRkFBbUY7b0JBQ25GLElBQUksQ0FBQyxvQkFBb0IsRUFBRSxDQUFDO2lCQUM3QjtnQkFFRCxPQUFPLE9BQU8sQ0FBQyxNQUFNLENBQUM7YUFDdkI7UUFDSCxDQUFDO0tBQUE7SUFDRCxvQkFBb0I7UUFDbEIsVUFBVSxDQUFDLEdBQUcsRUFBRTtZQUNkLElBQUksQ0FBQyxvQkFBb0IsRUFBRSxDQUFDO1FBQzlCLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNULENBQUM7SUFDRCxLQUFLO1FBQ0gsSUFBSSxDQUFDLGNBQWMsR0FBRyxDQUFDLENBQUM7UUFDeEIsSUFBSSxDQUFDLGFBQWEsR0FBRyxDQUFDLENBQUMsQ0FBQztRQUN4QixJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssRUFBRSxDQUFDO1FBQ3BCLElBQUksQ0FBQyxXQUFXLElBQUksSUFBSSxDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxLQUFLLEVBQUUsQ0FBQyxDQUFDO0lBQ3pFLENBQUM7SUFDRCxVQUFVO1FBQ1IsT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFDLGNBQWMsS0FBSyx5QkFBYyxDQUFDLGVBQWUsQ0FBQztJQUN2RSxDQUFDO0lBQ0ssb0JBQW9COztZQUN4QixpREFBaUQ7WUFDakQsSUFBSSxhQUFhLEdBQUcsS0FBSyxDQUFDO1lBQzFCLE9BQU8sQ0FBQyxhQUFhLEVBQUU7Z0JBQ3JCLE1BQU0sSUFBSSxHQUFHLE1BQU0sSUFBSSxDQUFDLHFCQUFxQixFQUFFLENBQUM7Z0JBRWhELElBQUksSUFBSSxFQUFFO29CQUNSLE9BQU8sSUFBSSxDQUFDLG9CQUFvQixFQUFFLEVBQUU7d0JBQ2xDLE1BQU0sTUFBTSxHQUFHLE1BQU0sSUFBSSxDQUFDLGVBQWUsRUFBRSxDQUFDO3dCQUM1QyxJQUFJLENBQUMsTUFBTSxDQUFDLE9BQU8sRUFBRTs0QkFDbkIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDO3lCQUN6QztxQkFDRjtvQkFDRCxJQUFJLElBQUksQ0FBQyxVQUFVLEVBQUUsRUFBRTt3QkFDckIsbUNBQW1DO3dCQUNuQyxvREFBb0Q7d0JBQ3BELDRDQUE0Qzt3QkFDNUMsTUFBTSxJQUFJLENBQUMscUJBQXFCLEVBQUUsQ0FBQzt3QkFDbkMsSUFBSSxJQUFJLENBQUMsVUFBVSxFQUFFLEVBQUU7NEJBQ3JCLGlEQUFpRDs0QkFDakQsYUFBYSxHQUFHLElBQUksQ0FBQzs0QkFDckIsSUFBSSxDQUFDLGNBQWMsRUFBRSxDQUFDO3lCQUN2QjtxQkFDRjt5QkFBTTt3QkFDTCxxREFBcUQ7d0JBQ3JELDZEQUE2RDt3QkFDN0QsOEJBQThCO3dCQUM5QixNQUFNLEdBQUcsR0FBRyxNQUFNLElBQUksQ0FBQyx3QkFBd0IsRUFBRSxDQUFDO3dCQUNsRCxJQUFJLEdBQUcsRUFBRTs0QkFDUCw2Q0FBNkM7NEJBQzdDLElBQUksQ0FBQyxJQUFJLENBQUMsb0JBQW9CLEVBQUUsRUFBRTtnQ0FDaEMsMEZBQTBGO2dDQUMxRixzQ0FBc0M7Z0NBQ3RDLGFBQWEsR0FBRyxJQUFJLENBQUM7NkJBQ3RCO3lCQUNGOzZCQUFNOzRCQUNMLGtCQUFrQjs0QkFDbEIsSUFBSSxDQUFDLGNBQWMsRUFBRSxDQUFDOzRCQUN0QixPQUFPO3lCQUNSO3FCQUNGO2lCQUNGO3FCQUFNO29CQUNMLGFBQWEsR0FBRyxJQUFJLENBQUM7aUJBQ3RCO2FBQ0Y7UUFDSCxDQUFDO0tBQUE7SUFDRCxPQUFPO1FBQ0wsTUFBTSxRQUFRLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLElBQUksQ0FBQyxVQUFVLEVBQUUsQ0FBQyxDQUFDO1FBQzVELE1BQU0sSUFBSSxHQUFHLElBQUksQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxDQUFDO1FBQ2xELElBQUksSUFBSSxFQUFFO1lBQ1IsTUFBTSxVQUFVLEdBQUcsSUFBa0IsQ0FBQztZQUV0QyxPQUFPLENBQUMsR0FBRyxRQUFRLEVBQUUsR0FBRyxVQUFVLENBQUMsT0FBTyxFQUFFLENBQUMsQ0FBQztTQUMvQzthQUFNO1lBQ0wsT0FBTyxRQUFRLENBQUM7U0FDakI7SUFDSCxDQUFDO0lBQ0QsY0FBYztRQUNaLElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQyxjQUFjLEtBQUsseUJBQWMsQ0FBQyxlQUFlLEVBQUU7WUFDakUsSUFBSSxDQUFDLE1BQU0sQ0FBQyxjQUFjLEVBQUUsQ0FBQztTQUM5QjtJQUNILENBQUM7SUFDSyx3QkFBd0I7O1lBQzVCLE9BQU8sSUFBSSxFQUFFO2dCQUNYLElBQUksSUFBSSxDQUFDLFVBQVUsRUFBRSxFQUFFO29CQUNyQixPQUFPLEtBQUssQ0FBQztpQkFDZDtnQkFDRCxNQUFNLElBQUksR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsQ0FBQztnQkFDbEQsTUFBTSxHQUFHLEdBQUcsTUFBTSxJQUFJLENBQUMsd0JBQXdCLEVBQUUsQ0FBQztnQkFDbEQsSUFBSSxHQUFHLEVBQUU7b0JBQ1AsT0FBTyxJQUFJLENBQUM7aUJBQ2I7cUJBQU07b0JBQ0wsSUFBSSxDQUFDLGFBQWEsR0FBRyxJQUFJLENBQUMsWUFBWSxFQUFFLENBQUM7aUJBQzFDO2FBQ0Y7UUFDSCxDQUFDO0tBQUE7Q0FDRjtBQWpRRCx3QkFpUUMifQ==